import React, { useEffect, useState } from "react";
import "./Container.css";
import Fade from "react-reveal/Fade";
import loader from "./../Cards/loader-timer-main.gif";
import { Link } from "react-router-dom";
import { FaLongArrowAltRight } from "react-icons/fa";
import { useMediaQuery } from "react-responsive";
import ProductCard from "./ProductCard";
import Marquee from "react-fast-marquee";
import PropTypes from "prop-types";

function ContainerFeaturedItems({ data }) {
  ContainerFeaturedItems.propTypes = {
    data: PropTypes.any.isRequired,
  };

  const [loading, setLoading] = useState(true);
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  useEffect(() => {
    if (data && data.length > 0) setLoading(false);
  }, [data]);

  return (
    <div className="featured-section bg-[#101c4c] py-[4rem] px-[1rem] text-center">
      {/* Section Header */}
      <Fade bottom>
        <h2 className="font-bold lg:text-5xl md:text-4xl text-3xl mb-[20px] title !text-white">
          Premium<span className="text-pent">.Gold Domains</span>
        </h2>
        <p className="max-w-[650px] mx-auto paragraph text-white text-base mb-[2.5rem]">
          Explore exclusive premium .gold domains available for acquisition.
          Invest in your digital future and elevate your brand’s global
          identity.
        </p>
      </Fade>

      {/* Loader */}
      {loading ? (
        <div className="flex flex-col items-center justify-center mt-[2rem]">
          <img src={loader} alt="Loading" className="w-[80px] mb-3" />
          <p className="paragraph text-white text-center">
            Loading premium .gold domains...
          </p>
        </div>
      ) : (
        <>
          {/* Desktop View */}
          {!isMobile && data && data.length > 0 && (
            <>
              {data.length <= 4 ? (
                // Static grid layout when ≤ 4 items
                <div className="flex flex-wrap justify-center gap-[25px] px-[20px]">
                  {data.map((product) => (
                    <div
                      key={product._id}
                      className="min-w-[300px] max-w-[400px] flex-grow"
                    >
                      <ProductCard product={product} />
                    </div>
                  ))}
                </div>
              ) : (
                // Marquee scroll when > 4 items
                <div className="relative w-full">
                  <Marquee
                    pauseOnHover
                    direction="left"
                    speed={25}
                    gradient={true}
                    gradientColor={[16, 28, 76]} // dark blue background blend
                    gradientWidth={120}
                  >
                    {data.map((product) => (
                      <div
                        key={product._id}
                        className="inline-block mx-[15px] min-w-[340px] max-w-[420px]"
                      >
                        <ProductCard product={product} />
                      </div>
                    ))}
                  </Marquee>
                </div>
              )}
            </>
          )}

          {/* Mobile View */}
          {isMobile && data && data.length > 0 && (
            <div className="flex overflow-x-auto hide-scrollbar gap-[16px] px-[10px]">
              {data.map((product) => (
                <div
                  key={product._id}
                  className="flex-shrink-0 min-w-[260px] max-w-[280px]"
                >
                  <ProductCard product={product} />
                </div>
              ))}
            </div>
          )}

          {/* Show More Button */}
          <div className="show-more-div mt-[3rem] flex justify-center">
            <Link to="/Marketplace">
              <button className="white-btn !border-[#b99653] !text-[#b99653] hover:!bg-[#b99653] hover:!text-white transition-all flex items-center gap-[8px] px-[22px] py-[10px] rounded-[8px]">
                Show More <FaLongArrowAltRight />
              </button>
            </Link>
          </div>
        </>
      )}
    </div>
  );
}

export default ContainerFeaturedItems;
